import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { AppConstants } from '../constants/app.constants';
import { AuthService } from '../services/auth/auth.service';
import { EmbedAuthService } from '../services/auth/embed-auth.service';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';

export const IS_SECURE_REQUEST = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private embedAuthService: EmbedAuthService) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const isSecureRequest = request.context.get(IS_SECURE_REQUEST);

    if (isSecureRequest) {
      if (this.authService.isAuthenticated() || this.embedAuthService.isEmbedded()) {
        let headers = request.headers;

        if (this.authService.isAuthenticated()) {
          headers = headers.append('x-location', this.authService.getCurrentLocation().toString());
          headers = headers.append('Authorization', this.authService.getAuthToken());
        }

        if (this.embedAuthService.isEmbedded()) {
          const authToken = this.embedAuthService.getAuthToken();
          if (authToken) {
            headers = headers.append('x-auth-jwt', authToken);
          }
        }
        request = request.clone({ headers });
      } else {
        this.authService.expireSession();
        throw new Error('Token Expired');
      }
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 &&
          this.embedAuthService.isEmbedded() &&
          error.error?.error?.message === AppConstants.invalidJWT
        ) {
          this.embedAuthService.setSessionInvalid();
        }
        return throwError(() => error);
      })
    );
  }
}
